import { createActions, createReducer } from 'reduxsauce'

import ParticipantesLicitacaoService from '../../servicos/ParticipantesLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaParticipantesLicitacaoInicio: [],
    buscaParticipantesLicitacaoSucesso: ['participantesLicitacao'],
    buscaParticipantesLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaParticipantesLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaParticipantesLicitacaoInicio())
        let serv = new ParticipantesLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaParticipantesLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaParticipantesLicitacaoErro(error)))
    }
}

const buscaParticipantesLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaParticipantesLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaParticipantesLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.participantesLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PARTICIPANTES_LICITACAO_INICIO]: buscaParticipantesLicitacaoInicio,
    [Types.BUSCA_PARTICIPANTES_LICITACAO_ERRO]: buscaParticipantesLicitacaoErro,
    [Types.BUSCA_PARTICIPANTES_LICITACAO_SUCESSO]: buscaParticipantesLicitacaoSucesso,
})
